import { render, staticRenderFns } from "./LiveDeviceList.vue?vue&type=template&id=08e4bb35&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./LiveDeviceList.vue?vue&type=script&lang=js&"
export * from "./LiveDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./LiveDeviceList.vue?vue&type=style&index=0&id=08e4bb35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4bb35",
  null
  
)

export default component.exports